import { useState, useEffect, useCallback, createContext, useContext } from 'react'
import axios from 'axios'
import swal from 'sweetalert'
import { GlobalContext } from './GlobalStatesProviders'
import { getLocalStorage, updateLocalStorage } from '../utils/globalFuntions'

export const CartContext = createContext();

export const CartContextProvider = ({ children }) => {

  const { apiUrlState } = useContext(GlobalContext);

  const [shoppingCart, setShoppingCart] = useState(() => {
    const cart = getLocalStorage('cart');
    return cart || [];
  })

  // States para manejo de componentes
  const [procomponents, setProcomponents] = useState(new Map());
  const [components, setComponents] = useState(new Map());

  // COMPONENTES
  const getComponentes = async () => {
    const url = `${apiUrlState}/Api/Componentes/GetComponentesHabilitados`;
    try {
      const response = await axios.get(url);
      if (response.status == 200) {
        const data = response.data.data;
        const mapProcomponents = new Map(
          data.map(item => [item.Referencia, item.Codigo])
        );
        setProcomponents(mapProcomponents);
        const mapComponents = new Map(
          data.map(item => [item.Codigo, item.Disponible > 0? item.Disponible : 0])
        );
        setComponents(mapComponents);
        refreshComponents();
      }      
    } catch (error) {
      alert('Error al obtener componentes');
    }
  }

  const updateComponent = (key, value) => {
    // console.log("updatecomponents", key, value)
    setComponents(prevComponents => {
      const newComponents = new Map(prevComponents); // Crear una nueva instancia del Map
      if (key) {
        const currentComponent = newComponents.get(key);
        const update = isNaN(currentComponent + value) ? 0 : currentComponent + value;
        newComponents.set(key, update);
      }
      return newComponents;
    });
  }

  /** Actualiza el state de componentes teniendo en cuenta los componentes usados */
  const refreshComponents = () => {
    setComponents(prevComponents => {
      const newComponents = new Map(prevComponents); // Crear una nueva instancia del Map
      shoppingCart.forEach(product => {
        const codComponent = product.Componente;
        if (codComponent) {
          const currentComponent = newComponents.get(codComponent);
          newComponents.set(codComponent, currentComponent - product.CantidadComp);
        }
      });
      return newComponents; // Retornar el nuevo Map
    });
  }

  // CARRITO

  /** Actualiza los valores Total unidades y Total valor */
  const updateTotalCart = useCallback ((state) => {
    let totalCart = 0;
    let countCart = 0;
    shoppingCart.forEach(item => {
      const price = state? item.PrecioMinorista : item.PrecioMayorista;
      const offer = state? item.DescuentoMinorista : item.DescuentoMayorista;
      const value = item.Cantidad * price * (1 - offer/100);
      countCart += item.Cantidad;
      totalCart += value;
    });
    return { countCart, totalCart };
  }, [shoppingCart]);

  const deleteProductCart = (product) => {
    const code = product.Codigo
    const newCart = shoppingCart.filter(item => item.Codigo !== code);
    setShoppingCart(newCart);
    updateComponent(product.Componente, product.CantidadComp);
    updateLocalStorage('cart', newCart);
  }

  const cleanCart = () => {
    setShoppingCart([]);
    updateLocalStorage('cart', []);
  }

  /** Obtiene las unidades de la talla seleccionada */
  const getCountVariant = (product, size) => {
    const variant = product?.Variantes?.[0]?.Tallas?.find(t => t.Talla === size);
    return variant?.Cantidad || 0;
  };

  /** Obtiene las unidades disponibles del componente */
  const getCountComponents = (reference) => {
    return components.get(procomponents.get(reference)) || 0;
  };

  /** Obtiene las unidades pedidas del disponible, del componente y total */
  const getOrderUnits = (reference) => {
    let availableOrders = 0; // unidades disponibles pedidas
    let componentOrders = 0; // unidades de componente pedidas
    let orders = 0; // unidades totales pedidas
    const product = shoppingCart.find(item => item.Codigo === reference);
    if (product) {
      availableOrders = product.CantidadDisp;
      componentOrders = product.CantidadComp;
      orders = product.Cantidad;
    }
    return { availableOrders, componentOrders, orders };
  }

  /** Obtiene las unidades disponibles de un producto */
  const getAvailableUnits = (product, size) => {
    const count = getCountVariant(product, size)
    const countComponent = getCountComponents(product.Referencia + size);
    const { availableOrders } = getOrderUnits(product.Referencia + size);
    const availableUnits = Math.max(count - availableOrders, 0);
    const availableComponent = Math.max(countComponent, 0);
    const available = availableUnits + availableComponent;
    return { availableUnits, availableComponent, available }
  }

  /** Realiza la validación previa para agregar un producto al carrito */
  const addProductToCart = useCallback((product, size, units) => {
    const { availableUnits, availableComponent, available } = getAvailableUnits(product, size);
    if (available >= units) {
      // Agrego al carrito
      auxProductToCart(product, size, availableUnits, units)
    } else {
      // Retorna aviso
      swal({
        title: "Aviso",
        text: `La cantidad solicitada de la referencia ${product.Referencia + size} no está disponible.
          Se agregarán ${available} de ${units} al carrito, desea continuar?`,
        icon: "info",
        buttons: {
          cancel: {
            text: "No",
            value: null,
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "Si",
            value: true,
            visible: true,
            closeModal: true
          }
        }
      }).then(response => {
        if(response && available > 0) {
          auxProductToCart(product, size, availableUnits, available);
        }
      });
    }
  }, [getAvailableUnits])

  /** Agrega o aumenta las unidades de un producto en el carrito */
  const auxProductToCart = (product, size, availableUnits, units) => {
    const updateCart = shoppingCart.reduce((cart, item) => {
      cart[item.Codigo] = item;
      return cart;
    }, {});
    const codigo = product.Referencia + size;
    const existItem = updateCart[codigo];
    const codComponent = procomponents.get(codigo);
    const { orderUnits, orderComponent } = distributionUnits(availableUnits, units);
    if (existItem) {
      existItem.CantidadDisp += orderUnits;
      existItem.CantidadComp += orderComponent;
      existItem.Cantidad += orderUnits + orderComponent;
    } else {
      const newVariant = {
        _id: product._id,
        Referencia: product.Referencia,
        Codigo: codigo,
        Nombre: product.Nombre,
        Categoria: product.Categoria.Categoria,
        Bodega: product.CodBodega,
        Componente: codComponent,
        CantidadDisp: orderUnits,
        CantidadComp: orderComponent,
        Cantidad: units, // Total
        Talla: size,
        PrecioMayorista: product.PrecioMayorista,
        PrecioMinorista: product.PrecioMinorista,
        DescuentoMayorista: product.DescuentoMayorista,
        DescuentoMinorista: product.DescuentoMinorista,
      };
      updateCart[codigo] = newVariant;
    }
    updateComponent(codComponent, -orderComponent)
    setShoppingCart(Object.values(updateCart));
    updateLocalStorage('cart', Object.values(updateCart));
  }

  /**
   * Distribuye las unidades a pedir entre disponibles y de componente
   * @param {number} availableUnits Unidades disponibles despues de pedidos
   * @param {number} availableComponent Unidades disponibles del componente
   * @param {number} units Unidades a pedir
   */
  const distributionUnits = (availableUnits, unitsToOrder) => {
    let orderUnits = 0;
    let orderComponent = 0;
    if (unitsToOrder <= availableUnits) {
      orderUnits = unitsToOrder;
    } else {
      orderUnits = availableUnits;
      orderComponent = unitsToOrder - orderUnits;
    }
    return { orderUnits, orderComponent };
  }

  /** Actualiza el carrito segun la notificacion de productos no permitidos */
  const updateNotAllowedProducts = useCallback((notAllowedProducts) => {
    // Actualizar carrito
    const updatedCart = shoppingCart.reduce((cart, item) => {
      cart[item.Codigo] = item;
      return cart;
    }, {});
    notAllowedProducts.forEach(product => {
      const code = product.Codigo;
      updatedCart[code] = product;
    });
    const newCart = Object.values(updatedCart).filter(item => item.Cantidad > 0);
    setShoppingCart(newCart);
    updateLocalStorage('cart', newCart);
  }, [shoppingCart]);

  useEffect(() => {
    if (shoppingCart.length == 0) {
      getComponentes()
    }
  }, [shoppingCart])

  useEffect(() => {
    getComponentes();
  }, [])

  return (
    <CartContext.Provider value={{
      components,
      procomponents,
      shoppingCart,
      setShoppingCart,
      updateTotalCart,
      deleteProductCart,
      cleanCart,
      updateComponent,
      refreshComponents,
      addProductToCart,
      updateNotAllowedProducts,
    }}>
      {children}
    </CartContext.Provider>
  )
}